import { render, staticRenderFns } from "./ImageSelector.vue?vue&type=template&id=37e0944c&scoped=true&"
import script from "./ImageSelector.vue?vue&type=script&lang=js&"
export * from "./ImageSelector.vue?vue&type=script&lang=js&"
import style0 from "./ImageSelector.vue?vue&type=style&index=0&id=37e0944c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e0944c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/dev/www/word-trainer-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VItem } from 'vuetify/lib'
import { VItemGroup } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCard,VContainer,VDialog,VFlex,VIcon,VItem,VItemGroup,VLayout,VProgressLinear,VRadio,VRadioGroup,VSpacer,VTextField,VToolbar,VToolbarTitle})
